<template>
  <v-container fluid fill-height>
    <v-row align="center" justify="center">
      <v-col cols="auto">
        <v-card class="elevation-1" v-if="!loading && activationSuccessful"> 
          <v-card-title>Account activated...</v-card-title>
          <v-card-text>Please <router-link to="/login">login</router-link> to access your order dashboard.</v-card-text>
        </v-card>
        <v-card class="elevation-1" v-if="!loading && !activationSuccessful"> 
          <v-alert v-if="emailSent" dense text type="success">If the email you entered is associated with a valid account you will receive an email with a new link shortly.</v-alert>
          <v-card-title>Unable to activate account...</v-card-title>
          <v-card-text v-if="activationExpired">
            Your activation link has expired or you have already activated your account. If you need to request a new activation link use the form below.
            <v-form ref="resendActivationForm">
              <v-text-field label="Email" v-model="email" outlined dense class="mt-3" :rules="rules.email"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-text v-else>Please check the link you used to access this page and try again.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="resendEmail">submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { activateAccount, resendActivationEmail } from '@/services/api/auth'
import {fieldRequired, validEmail} from '@/form-rules/index'

export default {
  name: "ActivateAccount",
  props: ["uid", "token"],
  data: () => {
    return {
      loading: true,
      activationSuccessful: false,
      activationExpired: false, 
      email: '',
      emailSent: false,

      rules: {
        email: [fieldRequired(), validEmail()]
      }
    };
  },
  methods: {
    resendEmail() {
      resendActivationEmail(this.email)
      .then(() => { this.emailSent = true })
      .catch(() => { this.emailSent = true })
    }
  },
  created() {
    activateAccount(this.uid, this.token)
    .then(() => {
      this.activationSuccessful = true
      this.loading = false
    })
    .catch((error) => {
      if (error.response.data.detail == "Stale token for given user.") {
        this.activationExpired = true
      }
      this.loading = false
    })
  }
};
</script>

<style></style>
